import { useEffect, useState } from "react";
import referandearn from "../../assets/images/referandearn.png";
import whatsapp from "../../assets/images/whatsapp.png";
import Swal from "sweetalert2";
import "./ReferEarnPage.scss";

const ReferEarnPage = () => {
  const baseUrl = process.env.REACT_APP_MERCHANTREFER_API_URL;

  const [referralLink, setReferralLink] = useState("");
  const [userType, setUserType] = useState("");
  const [mobile, setMobile] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsLoading(false);
      return;
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/profile`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (res.status === 401) {
        localStorage.setItem("isLoggedIn", "false");
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }

      if (res.ok) {
        const data = await res.json();

        if (data.message === "Invalid Token") {
          localStorage.setItem("isLoggedIn", "false");
          localStorage.removeItem("token");
          const isLoggedIn = localStorage.getItem("isLoggedIn");
          if (isLoggedIn !== "true") {
            window.location.href = "/login";
          }
        } else {
          const roles = data.data.user_type;
          const userMobile = data.data.mobile;

          setUserType(roles);
          setMobile(userMobile);

          const generatedLink = `${baseUrl}/auth/associate-register?parent_id=${userMobile}`;
          setReferralLink(generatedLink);
        }
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const copyReferralLink = () => {
    if (!referralLink) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(referralLink)
          .then(() => {
            Swal.fire({
              title: "REFER & EARN COPIED!",
              text: "Referral URL has been copied to clipboard.",
              icon: "success",
              confirmButtonText: "OK",
              position: "center",
              timer: 2000,
              showConfirmButton: true,
            });
          })
          .catch((err) => {
            console.error("Clipboard write failed, using fallback:", err);
            fallbackCopy(referralLink);
          });
      } else {
        fallbackCopy(referralLink);
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      fallbackCopy(referralLink);
    }
  };

  const fallbackCopy = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    Swal.fire({
      title: "REFER & EARN COPIED!",
      text: "Referral URL copied using fallback method.",
      icon: "success",
      confirmButtonText: "OK",
      position: "center",
      timer: 2000,
      showConfirmButton: true,
    });
  };

  return (
    <div className="refer-earn-page">
      {/* ═══════════ HERO CARD ═══════════ */}
      <div className="refer-hero-card">
        <div className="refer-hero-content">
          <div className="refer-hero-text">
            <span className="refer-badge">🎁 Refer & Earn</span>
            <h1>
              Invite Friends & <span>Earn Rewards</span>
            </h1>
            <p>
              Share your unique referral link with friends and earn amazing
              rewards when they sign up.
            </p>

            <div className="refer-link-box">
              <input
                type="text"
                value={referralLink || "Generating referral link..."}
                readOnly
                className="refer-link-input"
              />
              <button
                className="refer-copy-btn"
                onClick={copyReferralLink}
                disabled={!referralLink}
              >
                Copy
              </button>
            </div>

            <div className="refer-share-row">
              <a
                href={`https://wa.me/?text=${encodeURIComponent(
                  `Join me on this platform: ${referralLink}`
                )}`}
                className="refer-share-btn whatsapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={whatsapp} alt="whatsapp" />
                Share on WhatsApp
              </a>
            </div>
          </div>

          <div className="refer-hero-image">
            <img src={referandearn} alt="refer and earn" />
          </div>
        </div>
      </div>

      {/* ═══════════ HOW IT WORKS ═══════════ */}
      <div className="refer-steps-card">
        <div className="refer-steps-header">
          <h2>How It Works</h2>
          <p>3 simple steps to start earning</p>
        </div>

        <div className="refer-steps-grid">
          <div className="refer-step-item">
            <div className="refer-step-number">1</div>
            <h3>Share Your Link</h3>
            <p>Share your unique referral link with friends</p>
          </div>

          <div className="refer-step-item">
            <div className="refer-step-number">2</div>
            <h3>They Sign Up</h3>
            <p>Your friends sign up using your link</p>
          </div>

          <div className="refer-step-item">
            <div className="refer-step-number">3</div>
            <h3>You Both Earn</h3>
            <p>You get rewards when they complete qualifying actions</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferEarnPage;